import type { BrandConfig } from "../../config/types.ts";

function toBase64(value: string): string {
  if (typeof Buffer !== "undefined") return Buffer.from(value, "utf8").toString("base64");
  return btoa(unescape(encodeURIComponent(value)));
}

function escapeXml(value: string): string {
  return value.replace(/[<>&"']/g, (ch) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;", "'": "&apos;" }[ch] as string));
}

export function brandPlaceholderSvg(brand: BrandConfig, mode: "logo" | "favicon"): string {
  const label = (brand.displayName || brand.name || "API").replace(" API", "");
  const color = brand.colors.primary || "#2563eb";
  const width = mode === "logo" ? 200 : 32;
  const height = mode === "logo" ? 40 : 32;
  const text = escapeXml(label.split(" ")[0].slice(0, 12));
  const fontSize = mode === "logo" ? 20 : 12;
  const textX = mode === "logo" ? 100 : 16;
  const textY = mode === "logo" ? 26 : 21;

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">` +
    `<rect width="${width}" height="${height}" fill="${color}"/>` +
    `<text x="${textX}" y="${textY}" text-anchor="middle" fill="#ffffff" font-size="${fontSize}" font-family="system-ui, sans-serif" font-weight="700">${text}</text>` +
    `</svg>`;

  return `data:image/svg+xml;base64,${toBase64(svg)}`;
}

/** Logo/favicon de la marca o placeholder neutro (nunca de otra marca) */
export function resolveBrandVisual(
  brand: BrandConfig,
  kind: "logo" | "favicon",
): string {
  const asset = brand.assets?.[kind];
  if (asset) return asset;
  return brandPlaceholderSvg(brand, kind === "favicon" ? "favicon" : "logo");
}